import React from 'react';
import { motion } from 'framer-motion';
import { painPoints, planningLoop } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-zinc-900" data-id="element-152" data-mp="2lmiwupexkjae">
      <div className="max-w-4xl mx-auto" data-id="element-153" data-mp="26yxyf8t0388t">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-154" data-mp="26xwhwot7ttjp">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-6 text-white" data-id="element-155" data-mp="21zlb6my7vz5p">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-zinc-400 leading-relaxed bg-zinc-950 p-6 md:p-8 rounded-2xl border border-zinc-800 text-left space-y-4" data-id="element-156" data-mp="1o1ekbqroqzfj">
            <p className="font-semibold text-white" data-id="element-157" data-mp="3idupeo8qw7it">Tomorrow you have another MMA session.</p>
            <p data-id="element-158" data-mp="3ncfoulg6an67">
              And instead of switching off for the day, you&apos;re still searching for drills,
              deciding which skill to teach, trying to connect striking with clinch or takedowns,
              and wondering whether the progression you created will actually work with the
              athletes who walk into the gym.
            </p>
            <p data-id="element-159" data-mp="27s74iq00dn3k">
              <span className="text-white font-semibold" data-id="element-160" data-mp="27utc2pmwg2ls">Not because you don&apos;t know MMA.</span>{' '}
              Because knowing MMA and having a complete coaching system are two different things.
            </p>
            <p data-id="element-161" data-mp="1b2zilgvh9bz4">Without structure, every session starts from an empty page.</p>
            <ul className="flex flex-wrap gap-x-4 gap-y-1 font-display font-bold text-amber-400" data-id="element-162" data-mp="1b52j4uu9ani3">
              {planningLoop.map(step => <li key={step} data-id="element-163" data-mp="1k34otnoxq4bp">{step}</li>)}
            </ul>
            <p className="font-semibold text-white" data-id="element-164" data-mp="30he3tr7aegpv">And next week, you do it all again.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-165" data-mp="2vhjdppvc5v5v">
          <h3 className="text-xl font-extrabold uppercase text-white mb-8 text-center" data-id="element-166" data-mp="1y2on131zb0ls">
            The real cost of building every MMA session from scratch
          </h3>
          <ul className="overflow-hidden rounded-xl border border-zinc-800 bg-zinc-950" data-id="element-167" data-mp="2756cdqcxk9d0">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="px-5 py-4 text-zinc-400 text-sm leading-relaxed border-t first:border-t-0 border-zinc-800" data-id="element-168" data-mp="1agi6fsehocjy" data-mpi={index}>
                <span className="mr-2 text-red-500" aria-hidden="true" data-id="element-169" data-mp="vprg6osjpliy">●</span>
                {point}
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-zinc-800" data-id="element-170" data-mp="o5q8ve2yzd0g">
            <p className="text-xl mt-4 text-zinc-300" data-id="element-171" data-mp="j6vpa9x6hkfa">Your coaching knowledge is already there.</p>
            <p className="text-2xl font-display font-black uppercase text-white mt-2" data-id="element-172" data-mp="e7aqq0lx7e33">
              What you need is a <span className="text-amber-400" data-id="element-173" data-mp="a5fjygl808hx">system</span> that helps you use
              it faster.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}